// screen: Forgot / reset password
import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { ApiError } from '@viewstream/api-client';
import { Button, Field, Input, EmptyState } from '@viewstream/ui';
import { api } from '~/app/api';
import { ProductName } from '~/app/brand';

export const Route = createFileRoute('/password/forgot')({ component: Forgot });

function Forgot() {
  const { t } = useLingui();
  const [email, setEmail] = React.useState('');
  const [state, setState] = React.useState<'idle' | 'sent' | 'unavailable'>('idle');
  const [busy, setBusy] = React.useState(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault(); setBusy(true);
    try { await api.POST('/v1/auth/password/forgot', { body: { email } }); setState('sent'); }
    catch (ex) { setState(ex instanceof ApiError && ex.isNotFound ? 'unavailable' : 'sent'); } // never reveal whether the email exists
    finally { setBusy(false); }
  }
  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-xl border border-border bg-surface p-8 shadow-card">
        <div className="mb-6"><ProductName /></div>
        {state === 'unavailable' ? <EmptyState title={t`Password reset is not available yet`} description={t`Ask your tenant admin to reset it for you until the control plane's M2 routes are deployed.`} /> :
         state === 'sent' ? <EmptyState title={t`Check your email`} description={t`If an account exists for that address, a reset link is on its way (valid for one hour).`} /> : (
          <form onSubmit={submit} noValidate>
            <h1 className="mb-4 text-xl font-semibold">{t`Reset your password`}</h1>
            <Field id="email" label={t`Email`}><Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} dir="ltr" required /></Field>
            <Button type="submit" className="w-full" loading={busy}>{t`Send reset link`}</Button>
          </form>
        )}
        <p className="mt-4 text-center text-sm"><a className="text-primary underline-offset-4 hover:underline" href="/login">{t`Back to sign in`}</a></p>
      </div>
    </main>
  );
}
